'use strict';

import {gsap} from 'gsap';
import {ScrollTrigger} from "gsap/ScrollTrigger.js"

const init = () => {
    if (document.querySelector('body').dataset.parallax) {
        gsap.registerPlugin(ScrollTrigger)

        gsap.utils.toArray('.parallax picture').forEach(picture => {
            const image = picture.querySelector('img')
            const timeline = gsap.timeline({
                scrollTrigger: {
                    trigger: picture,
                    scrub: true,
                    pin: false,
                }
            })

            timeline.fromTo(image, {
                yPercent: 20,
                ease: 'none'
            }, {
                yPercent: -20,
                ease: 'none'
            })
        })
    }
}

export default {init}
